"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const CloseIcon_1 = __importDefault(require("./CloseIcon"));
const styles_scss_1 = __importDefault(require("../styles.scss"));
const constants_1 = require("../constants");
const DeleteButton = (props) => {
    var _a;
    const { onRenderContent } = props;
    return (react_1.default.createElement("span", { "data-component-name": "DeleteButton", role: "button", className: (0, classnames_1.default)(constants_1.JS__TOKEN__DELETE_BUTTON__CLASS_NAME, styles_scss_1.default['token__delete-button']), "aria-hidden": "true" }, (_a = onRenderContent === null || onRenderContent === void 0 ? void 0 : onRenderContent()) !== null && _a !== void 0 ? _a : react_1.default.createElement(CloseIcon_1.default, null)));
};
exports.default = DeleteButton;
